import authHeader from '@/backend/auth/auth-header';
import { useAxiosCreate } from '@/backend/utils';
import { serializeDowntimeParams } from '@/backend/downtimeParams.mjs';

const api = useAxiosCreate('trips');

const requestConfig = (params = {}) => ({
  params,
  headers: authHeader(),
  paramsSerializer: { serialize: serializeDowntimeParams },
});

export function fetchDowntimes(params) {
  return api.get('downtimes', requestConfig(params)).then((response) => response.data);
}

export function fetchTripDowntimeStatuses(tripId) {
  return api.get(`${tripId}/downtime-statuses`, requestConfig()).then((response) => response.data);
}

export function fetchDowntimeFilterOptions() {
  return api.get('downtimes/filter-options', requestConfig()).then((response) => response.data);
}

export function exportDowntimes(params) {
  return api.get('downtimes/export', {
    ...requestConfig(params),
    responseType: 'blob',
  });
}

export function registerDowntime(routePointId, payload) {
  return api.post(`downtimes/${routePointId}/register`, payload, { headers: authHeader() }).then((response) => response.data);
}

export function resolveDowntime(routePointId, payload) {
  return api.post(`downtimes/${routePointId}/resolve`, payload, { headers: authHeader() }).then((response) => response.data);
}

export function fetchDowntimeAct(routePointId) {
  return api.get(`downtimes/${routePointId}/act`, { headers: authHeader(), responseType: 'blob' });
}
